'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

/*eslint-disable sort-keys */

var searchDisplayTypes = {
    DISPLAY_AUCTION: 'DISPLAY_AUCTION',
    DISPLAY_BUY_NOW: 'DISPLAY_BUY_NOW',
    DISPLAY_PRICE_RESULTS: 'DISPLAY_PRICE_RESULTS'
};

exports.default = searchDisplayTypes;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/enums/searchDisplayTypes.js
// module id = r/V5
// module chunks = 60